export default function setCapterraConversionTrackingPixel() {
  const capterraVKey = 'ac5532b904572ebaed7fc5b5c715c29f';
  const capterraVid = '2097242';
  const capterraPrefix =
    document.location.protocol === 'https:' ? 'https://ct.capterra.com' : 'http://ct.capterra.com';

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = `${capterraPrefix}/capterra_tracker.js?vid=${capterraVid}&vkey=${capterraVKey}`;

  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
}
